import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Input, Button, Dropdown } from 'sfy-react'
import { postRequestAsync } from '../../../common/genericApi'
import { checkValues } from '../../../utils/regex'
import { setLoader } from '../../../store/common'

const COUNTRY_OPTIONS = [
  {
    key: 'in',
    value: 'India',
    uriKey: 'uriIN',
  },
  {
    key: 'us',
    value: 'US',
    uriKey: 'uriUS',
  },
  {
    key: 'eu',
    value: 'Europe',
    uriKey: 'uriEU',
  },
  {
    key: 'croma',
    value: 'Croma',
    uriKey: 'uriCroma',
  },
]

const ForgotPassword = ({ changeRoute, onSuccessChange }) => {
  const dispatch = useDispatch()
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [emailAddress, setEmailAddress] = useState('')
  const [selectedRegion, setSelectedRegion] = useState({})
  const [countryOptions, setCountryOptions] = useState(COUNTRY_OPTIONS)

  const [email, setEmail] = useState({
    value: '',
    placeholder: 'Enter your registered email address',
    error: '',
  })

  useEffect(() => {
    if (onSuccessChange) {
      onSuccessChange(isSuccess)
    }
  }, [isSuccess, onSuccessChange])

  useEffect(() => {
    let { isValid, isEmpty, error } = checkValues({ email: email.value })
    if (isEmpty) return
    if (isValid) setEmail((prevState) => ({ ...prevState, error: '' }))
    else if (isEmpty) setEmail((prevState) => ({ ...prevState, error: 'Please enter email address' }))
    else if (error) setEmail((prevState) => ({ ...prevState, error: error.email }))
  }, [isSubmitted, email.value])

  useEffect(() => {
    const filteredOptions = COUNTRY_OPTIONS.filter((eachCountry) => window[eachCountry['uriKey']])
    setCountryOptions(COUNTRY_OPTIONS.filter((eachCountry) => window[eachCountry['uriKey']]))

    if (localStorage.getItem('selectedRegion')) {
      const selectedRegionOption = filteredOptions.filter((opt) => opt.key === localStorage.getItem('selectedRegion'))
      handleCountrySelection(selectedRegionOption[0])
    } else {
      handleCountrySelection(filteredOptions[0])
    }
  }, [])

  const handleCountrySelection = (selectedOption) => {
    localStorage.setItem('selectedRegion', selectedOption.key)
    setSelectedRegion(selectedOption)
  }

  const handleOnSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitted(true)
    if (!email.error && email.value) {
      try {
        dispatch(setLoader(true))
        let response = await postRequestAsync('/user/forgotPassword', {
          username: email.value,
          region: selectedRegion?.key,
        })
        if (response.success) {
          setEmailAddress(email.value)
          setIsSuccess(true)
        }
        dispatch(setLoader(false))
      } catch (e) {
        console.log(e)
        setEmail({ ...email, error: e.msg || 'Could not send reset password link.' })
        dispatch(setLoader(false))
      }
    }
  }

  const handleOnChange = (e) => {
    setIsSubmitted(false)
    setEmail({
      ...email,
      value: e.target.value.trim(),
    })
  }

  const handleSignIn = () => {
    window.location.href = '/login'
  }

  // Success Screen
  if (isSuccess) {
    return (
      <div className='forgot-password-success'>
        <div className='forgot-password-success__icon'>
          <img src={`/${window.appName}/images/confirmed-animation.gif`} alt='Confirmed' />
        </div>
        <div className='forgot-password-success__title'>Password reset link sent</div>
        <div className='forgot-password-success__message'>
          Password Reset Link has been sent to <strong>{emailAddress}</strong>. Please click the link and follow the steps to reset your password.
        </div>
        <Button
          type='button'
          text='Sign In to My Account'
          classes='button-primary forgot-password-success__button'
          handleOnClick={handleSignIn}
        />
      </div>
    )
  }

  // Form Screen
  return (
    <>
      <div className='label mb5'>Your Region</div>
      <Dropdown
        classObject={{ container: `small-dropdown country-dropdown` }}
        options={countryOptions}
        value={selectedRegion?.value}
        handleOnChange={(value) => {
          handleCountrySelection(value)
        }}
        filterBy='value'
        searchText='Choose region'
        isDisabled={false}
      />
      <form onSubmit={handleOnSubmit}>
        <Input
          label='Registered Email Address'
          placeholder={email.placeholder}
          message={{ value: email.error }}
          className={{ message: email.error ? 'error' : '', label: 'label' }}
          value={email.value}
          handleOnChange={handleOnChange}
          name={'email'}
          otherProps={{ autoFocus: true }}
        />
        <Button
          type='submit'
          text='Send Password Reset Link'
          classes='button-primary button-submit mt30'
          isDisabled={!email.value || email.error}
        />
        <div className='forgot-password-instruction mt20'>
          A password reset link will be sent to your registered email address to reset your password.
        </div>
      </form>
    </>
  )
}

export default ForgotPassword
